import { MainV3ApiBase } from './base';
import { Moment } from 'moment-timezone';
import { CoachPositionId } from '../../adminv3/types/session';
import { CoachPositionIndexView } from '../types/coachPositions';

export const CoachPositionApis = {
    base() {
        return MainV3ApiBase.appendPath('coach_positions');
    },
    findAll(startsAt: Moment, endsAt: Moment): Promise<CoachPositionIndexView[]> {
        return this.base().get({
            starts_at: startsAt.format('YYYY-MM-DD'),
            ends_at: endsAt.format('YYYY-MM-DD'),
        });
    },
};

export const UserCoachPositionApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/coach_positions');
    },
    findAll(): Promise<CoachPositionIndexView[]> {
        return this.base().get();
    },
};

export const CoachPositionReservationApis = {
    base() {
        return MainV3ApiBase.appendPath('coach_positions/:id/reservations');
    },
    create(id: CoachPositionId) {
        return this.base()
            .bind({ id })
            .post();
    },
    delete(id: CoachPositionId) {
        return this.base()
            .bind({ id })
            .delete();
    },
};
